import { PERMISSIONS_MAP, PERMS } from '@/config/permissions'

const permissionsHelper = {
  getUserFriendlyMessage(type, route = {}) {
    let title  = null
    let errMsg = 'Нет прав'
    try {
      if (route && route.route) {
        route = route.route
      }
      let matched = route.matched || [route]
      for (let i = matched.length; i > -1; i--) {
        if (matched?.[i]?.meta?.title) {
          title = matched[i].meta.title
        }
      }
    } catch (e) {
      console.error(e)
    }
    if (type === PERMS.VIEW) {
      return `Нет прав на просмотр раздела ${title}`
    } else if (type === PERMS.DELETE) {
      errMsg = 'Нет прав на удаление'
    } else if (type === PERMS.EDIT) {
      errMsg = 'Нет прав на редактирование'
    } else if (type === PERMS.CREATE) {
      errMsg = 'Нет прав на создание'
    }
    if (title) {
      errMsg += ' в разделе ' + title
    }
    return errMsg
  },
  findSeparatePermission(permissionName, asPermObject = false) {
    for (let objKey in PERMISSIONS_MAP) {
      if (PERMISSIONS_MAP?.[objKey]?.permissions?.[permissionName]) {
        return !!asPermObject ? PERMISSIONS_MAP[objKey] : PERMISSIONS_MAP[objKey].permissions[permissionName]
      }
    }
    return null
  },
  findModulePermission(routeName, permissionName) {
    return PERMISSIONS_MAP?.[routeName]?.permissions?.[permissionName] || null
  }
}

export default permissionsHelper
